import { render, staticRenderFns } from "./CardLayoutInstruction.vue?vue&type=template&id=6f621ab4"
import script from "./CardLayoutInstruction.vue?vue&type=script&lang=js"
export * from "./CardLayoutInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports